.switch { display: none; }

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

@media (max-width: 699px) {
  .text { display: none; }

  .switch {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    padding: 0;
    font: inherit;
    letter-spacing: inherit;
    color: inherit;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .chevron {
    display: grid;
    flex-shrink: 0;
    place-items: center;
    width: 26px;
    height: 26px;
    color: var(--text2);
    background: var(--table-even);
    border: 1px solid var(--border);
    border-radius: 50%;
  }

  .switch:focus-visible { outline: 2px solid var(--blue); outline-offset: 3px; border-radius: 6px; }
}
